const uploadAudioUsingPresignedUrl = async (
  url,
  audioBlobForAudioPlayer,
  abortController
) => {
  abortController.current = new AbortController();

  const options = {
    signal: abortController.current.signal,
    method: "PUT",
    headers: {
      "Content-Type": "application/octet-stream",
    },
    body: audioBlobForAudioPlayer,
  };

  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      const errorResponse = await response.json();
      throw new Error(
        `Failed to upload audio: ${JSON.stringify(errorResponse)} ${response.status}`
      );
    }
  } catch (error) {
    throw new Error("Error while uploading audio", { cause: error });
  }
};

export default uploadAudioUsingPresignedUrl;
